module.exports = __webpack_public_path__ + "static/icons/icon-forecast--white-3d584e59382d0a02dc4497f968e39e4f.svg";